import { ArrowUpRight } from 'lucide-react';
import {
  WHATSAPP_URL,
  WHATSAPP_PHONE,
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  MAPS_URL,
  MAPS_EMBED_URL,
} from '../constants';
import { useMotion } from '../lib/motion';

const linkCls = "inline-flex items-center gap-1 mt-3 font-semibold text-ink underline decoration-tan decoration-2 underline-offset-4 hover:text-tan";

export default function Location() {
  const scope = useMotion();

  return (
    <section ref={scope} id="contato" data-testid="location-section" className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
      <h2 data-lines className="text-4xl md:text-5xl font-extrabold tracking-tight leading-none text-ink mb-10 md:mb-14">
        Como chegar
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10">
        <div data-rise="0" data-testid="address-info">
          <h3 className="text-sm text-soft mb-2">Endereço</h3>
          <p className="text-lg font-semibold text-ink leading-snug">
            {ADDRESS_LINE1}<br />{ADDRESS_LINE2}
          </p>
          <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="directions-btn">
            Abrir no Google Maps
            <ArrowUpRight size={18} strokeWidth={1.75} aria-hidden="true" />
          </a>
        </div>

        <div data-rise="0.1" data-testid="hours-info">
          <h3 className="text-sm text-soft mb-2">Horário</h3>
          <p className="text-lg font-semibold text-ink leading-snug">
            Segunda a sábado<br />das 7h30 às 17h30
          </p>
        </div>

        <div data-rise="0.2" data-testid="phone-info">
          <h3 className="text-sm text-soft mb-2">Dúvidas pelo WhatsApp</h3>
          <p className="text-lg font-semibold text-ink leading-snug">{WHATSAPP_PHONE}</p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="contact-whatsapp-link">
            Mandar mensagem
            <ArrowUpRight size={18} strokeWidth={1.75} aria-hidden="true" />
          </a>
        </div>
      </div>

      <div data-rise="0.2" className="rounded-2xl overflow-hidden border border-rule h-72 md:h-[420px]" data-testid="map-container">
        <iframe
          src={MAPS_EMBED_URL}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa com a localização do salão Nyjuliabraids"
          data-testid="google-map"
        />
      </div>
    </section>
  );
}
